module.exports = __webpack_public_path__ + "static/media/eyeballparty.ffab2a18.gif";